import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import './App.css';

import Header from './components/common/Header';
import Footer from './components/common/Footer';
import Routes from './Routes';

const styles = () => ({
  root: {
    margin: '0px',
    padding: '0px',
  },
});

class App extends Component {

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Header />
        <Routes />
        <Footer />
      </div>
    );
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(App);



// WEBPACK FOOTER //
// ./src/App.js